import CocaCola from '../assets/images/drinks-images/cocacola2.webp'
import ColaZero from '../assets/images/drinks-images/colazero.webp'
import FantaExotic from '../assets/images/drinks-images/fantaexotic2.webp'
import MezzoMix from '../assets/images/drinks-images/mezzomix2.webp'
import Sprite from '../assets/images/drinks-images/sprite.webp'
import Almdudler from '../assets/images/drinks-images/almdudler2.webp'
import IceTeaCitrus from '../assets/images/drinks-images/iceteacitrus.webp'
import IceTeaPeach from '../assets/images/drinks-images/iceteapeach.webp'
import MineralSpark from '../assets/images/drinks-images/mineralsparkling.webp'
import MineralStill from '../assets/images/drinks-images/mineralstill.webp'

//Zutaten
import Rucola from '../assets/images/pasta-images/rucola.webp'
import Mais from '../assets/images/pasta-images/corn.webp'
import Zwiebeln from '../assets/images/pasta-images/onion.webp'
import Champignons from '../assets/images/pasta-images/mushroom.webp'
import Zucchini from '../assets/images/pasta-images/zucchini.webp'
import Melanzane from '../assets/images/pasta-images/eggplant.webp'
import Artischocken from '../assets/images/pasta-images/artichoke.webp'
import Sardellen from '../assets/images/pasta-images/sardella.webp'
import Kirschtomaten from '../assets/images/pasta-images/cherrytomato.webp'
import Getrocknete from '../assets/images/pasta-images/suntomato.webp'
import Kapern from '../assets/images/pasta-images/capers.webp'
import Padano from '../assets/images/pasta-images/granapadano.webp'
import Ei from '../assets/images/pasta-images/egg.webp'
import Schinken from '../assets/images/pasta-images/cookedham.webp'
import Salami from '../assets/images/pasta-images/salami.webp'
import Scharfe from '../assets/images/pasta-images/spicysalami.webp'
import Streichwurst from '../assets/images/pasta-images/spreadablesausage.webp'
import Salsiccia from '../assets/images/pasta-images/freshsausage.webp'
import Thunfisch from '../assets/images/pasta-images/tuna.webp'
import Gorgonzola from '../assets/images/pasta-images/gorgon.webp'
import Rohschinken from '../assets/images/pasta-images/prosciutto.webp'
import Speck from '../assets/images/pasta-images/bacon.webp'
import Büffelmozzarella from '../assets/images/pasta-images/mozarella.webp'

//Pizza
import Pizzabrot from '../assets/images/pizzabrot.webp'
import Margherita from '../assets/images/margheritapizza.webp'
import SalamiP from '../assets/images/salamipizza.webp'
import Regina from '../assets/images/reginapizza.webp'
import Diavola from '../assets/images/diavolapizza.webp'
import Tonno from '../assets/images/pizzatonno.webp'
import Capricciosa from '../assets/images/pizzacapricciosa.webp'
import Capricciosa2 from '../assets/images/capricciosa2.webp'
import Boscaiola from '../assets/images/boscaiola.webp'
import Quattro from '../assets/images/4cheese.webp'
import Prosciutto from '../assets/images/pizzaprosciutto.webp'
import Montagne from '../assets/images/montagne.webp'
import Bufala from '../assets/images/buffalopizza.webp'
import Viola from '../assets/images/forzaviola.webp'
import Carbonara from '../assets/images/pizzacarbonara.webp'
import Norma from '../assets/images/pizzanorma.webp'
import Sixty9 from '../assets/images/pizza69.webp'
import Casaantonio from '../assets/images/casaantonio.webp'
import Mare from '../assets/images/pizzamare.webp'
import Biacaneve from '../assets/images/pizzabiacaneve.webp'
import Biacaneve2 from '../assets/images/pizzabicanevegorgonzola.webp'
import Carmelo from '../assets/images/pizzacarmelo.webp'
import Dolce from '../assets/images/dolce.webp'
import Halb from '../assets/images/pizzahalb.webp'
//Salad
import Insalata from '../assets/images/sushi-images/salad.webp'


export const allProductsData = [
  {
    id: 'quattro',
    ItemImg: Quattro,
    ItemName: 'Quattro Formaggi',
    ItemIngredients: 'Tomatensauce, Mozzarella, Taleggio, Gorgonzola, Parmesan.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },

  {
    id: 'pizzabrot',
    ItemImg: Pizzabrot,
    ItemName: 'Pizzabrot',
    ItemIngredients:
      'Tomatensauce, Oregano, Olivenöl.',
    ItemPrice: (6).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'margherita',
    ItemImg: Margherita,
    ItemName: 'Margherita',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Basilico fresco.',
    ItemPrice: (10).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'salamiP',
    ItemImg: SalamiP,
    ItemName: 'Salami',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Salami, Pfefferoni.',
    ItemPrice: (13).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'regina',
    ItemImg: Regina,
    ItemName: 'Regina',
    ItemIngredients:
      'Prosciutto cotto, Tomatensauce, Mozzarella, frische Champignons.',
    ItemPrice: (13).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'diavola',
    ItemImg: Diavola,
    ItemName: 'Diavola',
    ItemIngredients:
      'Tomatensauce, Mozzarella, scharfe Salami',
    ItemPrice: (13).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'tonno',
    ItemImg: Tonno,
    ItemName: 'Tonno',
    ItemIngredients: 'Tomatensauce, Mozzarella, Thunfisch, frusche Zwiebeln, Knoblauchöl, Petersilie.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'prosciutto',
    ItemImg: Prosciutto,
    ItemName: 'Prosciutto und rucola',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Prosciutto Crudo, Rucola, gehobeltem Parmesan.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'capricciosa',
    ItemImg: Capricciosa,
    ItemName: 'Capricciosa',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Schinken, Champignons, Artischoken, Oliven.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'capricciosa2',
    ItemImg: Capricciosa2,
    ItemName: 'Capricciosa Special',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Champignons, gegrillter Melanzani, Artischoken, Rucola, Knoblauchöl.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'boscaiola',
    ItemImg: Boscaiola,
    ItemName: 'Boscaiola',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Salsiccia fresca.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'montagne',
    ItemImg: Montagne,
    ItemName: 'Montagne di Salisburgo',
    ItemIngredients: 'Tomatensauce, Mozzarella, Speck, Gorgonzola.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'bufala',
    ItemImg: Bufala,
    ItemName: 'Bufala',
    ItemIngredients:
      'Tomatensauce, echtem Mozzarella di Bufala, Tomaten, frischem Basilikum.',
    ItemPrice: (15).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'viola',
    ItemImg: Viola,
    ItemName: 'Forza Viola',
    ItemIngredients: 'Tomatensauce, Mozzarella, Salsiccia fresca, gegrillter Melanzani, echtem Mozzarella di Bufala, Knoblauch.',
    ItemPrice: (15.50).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'norma',
    ItemImg: Norma,
    ItemName: 'Norma',
    ItemIngredients:
      'Tomatensauce, Mozzarella, gegrillter Melanzani, gehobeltem Parmesan, Tomaten, frischem Basilikum, Ricotta, Knoblauchöl.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'sixty9',
    ItemImg: Sixty9,
    ItemName: '69',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Sasiccia fresca, Ricotta, Oregano, frisch gemahlenem Pfeffer, Knoblauch, Mini Mozzarella, Knoblauchöl.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'casaantonio',
    ItemImg: Casaantonio,
    ItemName: 'Casaantonio',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Ricotta, Sardellen, Tomaten, Basilikum, Knoblauchöl.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'mare',
    ItemImg: Mare,
    ItemName: 'Mare',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Meeresfrüchte, Zitronenöl, Knoblauch.',
    ItemPrice: (16).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'biacaneve',
    ItemImg: Biacaneve,
    ItemName: 'Biacaneve',
    ItemIngredients: 'Mozzarella, Ricotta, Gorgonzola, Mini-Mozzarella, gehobeltem Parmesan, Knoblauchöl, frisch gemahlenem Pfeffer.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'biacaneve2',
    ItemImg: Biacaneve2,
    ItemName: 'Biacaneve',
    ItemIngredients:
      'Mozzarella, getrockneten Tomaten, Oliven, Sasiccia fresca, Rucola, Knoblauchöl.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'carmelo',
    ItemImg: Carmelo,
    ItemName: 'Carmelo',
    ItemIngredients:
      'Mozzarella, Salsiccia fresca, Gorgonzola, Pfefferoni, Oregano.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'carbonara',
    ItemImg: Carbonara,
    ItemName: 'Carbonara',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Ei, Speck, gehobelter Grana Padano, gemahlenem Pfeffer, Knoblauchöl.',
    ItemPrice: (14).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'dolce',
    ItemImg: Dolce,
    ItemName: 'Pizza Dolce',
    ItemIngredients:
      'Sizilianischer Palatschinken mit Haselnusscreme im Hefeteig gebacken und Staubzucker.',
    ItemPrice: (7.50).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'halb',
    ItemImg: Halb,
    ItemName: 'Pizza Halb',
    ItemIngredients:
      'Auswahl von zwei verschiedenen Pizzabelägen, jeweils auf einer Hälfte der Pizza.',
    ItemPrice: (16).toFixed(2),
    Category: 'Pizza',
  },
  {
    id: 'rucola',
    ItemImg: Rucola,
    ItemName: 'Rucola',
    ItemIngredients:
      'Rucola',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'mais',
    ItemImg: Mais,
    ItemName: 'Mais',
    ItemIngredients:
      'Mais',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'zwiebeln',
    ItemImg: Zwiebeln,
    ItemName: 'Zwiebeln',
    ItemIngredients:
      'Zwiebeln',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'champignons',
    ItemImg: Champignons,
    ItemName: 'Champignons',
    ItemIngredients:
      'Champignons',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'melanzane',
    ItemImg: Melanzane,
    ItemName: 'Melanzane',
    ItemIngredients:
      'Melanzane',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'zucchini',
    ItemImg: Zucchini,
    ItemName: 'Zucchini',
    ItemIngredients:
      'Zucchini',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'artischocken',
    ItemImg: Artischocken,
    ItemName: 'Artischocken',
    ItemIngredients:
      'Artischocken',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'sardellen',
    ItemImg: Sardellen,
    ItemName: 'Sardellen',
    ItemIngredients: 'Sardellen',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'getrocknete',
    ItemImg: Getrocknete,
    ItemName: 'Getrocknete Tomaten',
    ItemIngredients:
      'Tomaten',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'kirschtomaten',
    ItemImg: Kirschtomaten,
    ItemName: 'Kirschtomaten',
    ItemIngredients:
      'Kirschtomaten',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'kapern',
    ItemImg: Kapern,
    ItemName: 'Kapern',
    ItemIngredients:
      'Kapern',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'padano',
    ItemImg: Padano,
    ItemName: 'Grana Padano',
    ItemIngredients:
      'Padano',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'ei',
    ItemImg: Ei,
    ItemName: 'Ei',
    ItemIngredients:
      'Ei',
    ItemPrice: (2).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'schinken',
    ItemImg: Schinken,
    ItemName: 'Gekochter Schinken',
    ItemIngredients:
      'Schinken',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'salami',
    ItemImg: Salami,
    ItemName: 'Salami',
    ItemIngredients:
      'Salami',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'scharfe',
    ItemImg: Scharfe,
    ItemName: 'Scharfe Salami',
    ItemIngredients: 'Salami',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'streichwurst',
    ItemImg: Streichwurst,
    ItemName: 'N`duja (scharfe Streichwurst)',
    ItemIngredients:
      'Streichwurst',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'salsiccia',
    ItemImg: Salsiccia,
    ItemName: 'Salsiccia Fresca',
    ItemIngredients:
      'Salsiccia',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'thunfisch',
    ItemImg: Thunfisch,
    ItemName: 'Thunfisch',
    ItemIngredients:
      'Thunfisch',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'gorgonzola',
    ItemImg: Gorgonzola,
    ItemName: 'Gorgonzola',
    ItemIngredients:
      'Gorgonzola',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'rohschinken',
    ItemImg: Rohschinken,
    ItemName: 'Rohschinken',
    ItemIngredients:
      'Rohschinken',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'speck',
    ItemImg: Speck,
    ItemName: 'Speck',
    ItemIngredients:
      'Speck',
    ItemPrice: (2.50).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'büffelmozzarella',
    ItemImg: Büffelmozzarella,
    ItemName: 'Büffelmozzarella',
    ItemIngredients:
      'Büffelmozzarella',
    ItemPrice: (4).toFixed(2),
    Category: '✚Zutaten',
    attributes: [],
  },
  {
    id: 'insalata-mista',
    ItemImg: Insalata,
    ItemName: 'Insalata Mista',
    ItemIngredients:
      'Various lettuce, Tomatoes, Cucumbers, Carrots, Red onions, Bell peppers, Olive oil, Vinegar, Salt, Pepper.',
    ItemPrice: (4.90).toFixed(2),
    Category: 'Salat',
    attributes: [],
  },
  {
    id: 'coca-cola-original-soda-pop',
    ItemImg: CocaCola,
    ItemName: 'Coca-Cola Original Soda Pop 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },

  {
    id: 'coca-cola-zero-soda-pop',
    ItemImg: ColaZero,
    ItemName: 'Coca-Cola Zero Soda Pop 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'fanta-exotic-soda-pop',
    ItemImg: FantaExotic,
    ItemName: 'Fanta Exotic Soda Pop 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'sprite-soda-pop',
    ItemImg: Sprite,
    ItemName: 'Sprite Soda Pop 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'mezzo-mix-soda',
    ItemImg: MezzoMix,
    ItemName: 'Mezzo Mix Soda 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'almdudler-soda-pop',
    ItemImg: Almdudler,
    ItemName: 'Almdudler Soda Pop 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'citrus-iced-tea',
    ItemImg: IceTeaCitrus,
    ItemName: 'Citrus Iced Tea 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'peach-iced-tea',
    ItemImg: IceTeaPeach,
    ItemName: 'Peach Iced Tea 0.33l',
    ItemPrice: (2.50).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'mineral-water-still',
    ItemImg: MineralStill,
    ItemName: 'Mineral Water Still 0.5l',
    ItemPrice: (3).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'mineral-water-spark',
    ItemImg: MineralSpark,
    ItemName: 'Mineral Water Sparkling 0.5l',
    ItemPrice: (3).toFixed(2),
    Category: 'Getränke',
    attributes: [],
  },
  {
    id: 'margherita-pizza-sale-second',
    ItemImg: Margherita,
    ItemName: 'Margherita Pizza',
    ItemIngredients:
      'Tomatensauce, Mozzarella, Basilico fresco.',
    ItemPriceBefore: (10).toFixed(2),
    ItemPrice: (9).toFixed(2),
    Category: 'Angebote',
    sale: true,
    attributes: [],
  },
  {
    id: 'veggie-pizza-sale-second',
    ItemImg: Carmelo,
    ItemName: 'Carmelo',
    ItemIngredients:
      'Mozzarella, Salsiccia fresca, Gorgonzola, Pfefferoni, Oregano.',
    ItemPriceBefore: (14).toFixed(2),
    ItemPrice: (12.50).toFixed(2),
    Category: 'Angebote',
    sale: true,
    attributes: [],
  },
  {
    id: 'cheese-pizza-sale-second',
    ItemImg: Quattro,
    ItemName: 'Quattro Formaggi',
    ItemIngredients: 'Tomatensauce, Mozzarella, Taleggio, Gorgonzola, Parmesan.',
    ItemPriceBefore: (14).toFixed(2),
    ItemPrice: (13).toFixed(2),
    Category: 'Angebote',
    sale: true,
    attributes: [],
  }
]
